import {ReactComponent as ArrowleftIcon} from "./arrow-left.svg";

const Arrowlefticon = () => {
    return (
        <ArrowleftIcon className='icon' />
    )
}
export default Arrowlefticon
